export const customReportsQueryKeys = {
  all: ['customReports'] as const,
  customSpreadsheetReports: ({
    publicationId,
    searchQuery,
    sortBy,
    limit,
    offset
  }: {
    publicationId: string;
    searchQuery: string;
    sortBy: string;
    limit: number;
    offset: number;
  }) =>
    [
      ...customReportsQueryKeys.all,
      'customSpreadsheetReports',
      publicationId,
      { searchQuery, sortBy, limit, offset }
    ] as const,
  namedRangesForTable: (spreadsheetId: string) =>
    [...customReportsQueryKeys.all, 'namedRangesForTable', spreadsheetId] as const,
  customReportStoryCounts: (spreadsheetIds: string[]) =>
    [...customReportsQueryKeys.all, 'customReportStoryCounts', ...spreadsheetIds.sort()] as const,
  createSpreadsheet: () => [...customReportsQueryKeys.all, 'insert_spreadsheets_one'] as const,
  getPresignedUrl: ({
    publicationId,
    spreadsheetId,
    fileName
  }: {
    publicationId: string;
    spreadsheetId: string;
    fileName: string;
  }) => [...customReportsQueryKeys.all, 'getPresignedUrl', publicationId, spreadsheetId, fileName] as const,
  updateSpreadsheet: () => [...customReportsQueryKeys.all, 'update_spreadsheets_by_pk'] as const,
  deleteSpreadsheet: () => [...customReportsQueryKeys.all, 'delete_spreadsheets_by_pk'] as const,
  namedRangesForEditReportModal: (spreadsheetId: string) =>
    [...customReportsQueryKeys.all, 'namedRangesForEditReportModal', spreadsheetId] as const,
  htmlForEditReportModalSelectedNamedRange: (namedRangeId: string) =>
    [...customReportsQueryKeys.all, 'htmlForEditReportModalSelectedNamedRange', namedRangeId] as const,
  postSpreadsheetTable: ({
    entityId,
    publicationId,
    storyId,
    storyContentId
  }: {
    entityId: number;
    publicationId: string;
    storyId: string;
    storyContentId: string;
  }) => [...customReportsQueryKeys.all, 'spreadsheetTable', entityId, publicationId, storyId, storyContentId] as const,
  putSpreadsheetTable: ({
    publicationId,
    storyId,
    storyContentId
  }: {
    publicationId: string;
    storyId: string;
    storyContentId: string;
  }) => [...customReportsQueryKeys.all, 'putSpreadsheetTable', publicationId, storyId, storyContentId] as const,
  namedRangeMarkup: ({
    publicationId,
    spreadsheetId,
    namedRangeId
  }: {
    publicationId: string;
    spreadsheetId: string;
    namedRangeId: string;
  }) => [...customReportsQueryKeys.all, 'namedRangeMarkup', publicationId, spreadsheetId, namedRangeId] as const,
  deleteSpreadsheetTable: ({ storyId, storyContentId }: { storyId: string; storyContentId: string }) =>
    [...customReportsQueryKeys.all, 'deleteSpreadsheetTable', storyId, storyContentId] as const
};
